export const COMPARE_PROJECT_IDS_KEY = "compare_project_ids";
export const COMPARE_PROJECT_SLUGS_KEY = "compare_project_slugs";

export const PATH_NAME = {
  COMPARE_PROJECTS: {
    all: (lang: string) => `/${lang}/compare-projects`,
  },
};
